module.exports = __webpack_public_path__ + "static/media/pic_story2.3a7ec68a.png";